import { Global, css } from '@emotion/react';
import { rem } from '@triumph/design-system';

export const FILE_TYPE_DROPDOWN_PANEL_CLASS = 'file-type-dropdown-panel';

const fileTypeDropdownPanelCss = css`
    .${FILE_TYPE_DROPDOWN_PANEL_CLASS} .p-dropdown-item {
        font-size: ${rem(14)};
        padding: ${rem(8)} ${rem(16)} ${rem(8)} ${rem(28)};
    }

    .${FILE_TYPE_DROPDOWN_PANEL_CLASS} .p-dropdown-item-group {
        font-size: ${rem(12)};
        font-weight: 700;
        padding: ${rem(8)} ${rem(16)};
        color: #6b7280;
        text-transform: uppercase;
        letter-spacing: 0.02em;
    }
`;

export const FileTypeDropdownPanelStyles = () => <Global styles={fileTypeDropdownPanelCss} />;
